import { spinner } from '../UI/spinner/spinner';
import './less/warrantyContactForm.less';

const WarrantyContactForm = function(){

	let _this = this;
	let form = $('#warranty-form');
	this.id = 'contactEnquiry';
	$('.zero').val(1);
	
	this.validate = () => {
		//console.log('validating');
	};
	
	this.send = form => {
		form.addClass("processing");
		spinner.show(form[0], '#151515');
		
		let formData = new FormData(form[0]);
		let send =  $.ajax({
			type: 'POST',
			url: form.attr('action') + '&rand=' + Math.random(),
			data: formData,
			contentType: false,
			processData: false,
		});
		
		send.done(response => {
			let data = $.parseJSON(response);
			
			spinner.remove();
			form.removeClass("processing");
			form.find("span.error").remove();
			form.find('.form-info').empty().append('<p>' + data.contents + '</p>').removeClass("error info warning ok").addClass(data.status);
			
			if (data.status === 'ok') {
				form.find("input[type='text'], input[type='email'], textarea, input[type='file']").val('');
				form.find(':checkbox, :radio').prop('checked', false);
				form.find('option:selected').prop('selected', false);
				
				//Set default phone value: UNUSED
				form.find('[data-default]').each(function () {
					form.val(form.data('default'));
				});

			} else {
				if (data.fields !== undefined) {
					for(let key in data.fields) {
						if(data.fields.hasOwnProperty(key)) {
							form.find(`.formField${key}`).after(`<span class="error">${data.fields[key]}</span>`);
						}
					}
				}
			}
		});
	};
	
	form.submit(function (e) {
		e.preventDefault();
		$('input, textarea').removeClass('error').removeClass('ok');
		_this.send(form);
	});
	
};

export { WarrantyContactForm };


// WEBPACK FOOTER //
// ../components/warrantyContactForm/warrantyContactForm.js